<h3>Other Guest Roles</h3>
<div id="table-description">The table below displays the user's guest role history. These roles cannot be edited or modified. </div>
@if (guestRoles.length > 0) {
  <app-guest-table [guests]="guestRoles" [includeName]="false"></app-guest-table>
}
@if (guestRoles.length == 0) {
  <div class="empty">Guest has no other past or present guest roles</div>
}